import { useState, useEffect } from 'react';
import {
  collection,
  query,
  where,
  orderBy,
  getDocs,
  doc,
  deleteDoc,
} from 'firebase/firestore';
import { db } from '../firebase';

export default function usePendencias(user) {
  const [pendencias, setPendencias] = useState([]);

  useEffect(() => {
    if (user) {
      const fetchPendencias = async () => {
        try {
          const q = query(
            collection(db, 'agenda'),
            where('userId', '==', user.uid),
            orderBy('dataHora', 'asc')
          );
          const querySnapshot = await getDocs(q);
          const pendenciasTemp = querySnapshot.docs.map((doc) => {
            const data = doc.data();
            return {
              ...data,
              id: doc.id,
              dataHora: data.dataHora.toDate(),
            };
          });

          setPendencias(pendenciasTemp);
        } catch (e) {
          console.error('Erro ao buscar pendências:', e);
        }
      };

      fetchPendencias();
    }
  }, [user]);

  const handleEncerrar = async (id) => {
    try {
      await deleteDoc(doc(db, 'agenda', id));
      setPendencias(pendencias.filter((pendencia) => pendencia.id !== id));
    } catch (e) {
      console.error('Erro ao encerrar o compromisso:', e);
    }
  };

  return { pendencias, handleEncerrar };
}
